import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Icon from '../components/Icon';

/** @param {Record<string, any>} props */
function Checkbox({
  checked = false,
  disabled = false,
  id,
  name,
  onChange = null,
  required = false,
  label = null,
  value = '',
  longDescription = null,
  shortDescription = null,
  ...checkboxProps
}) {
  const [isChecked, setIsChecked] = useState(Boolean(checked));

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  return (
    <div className="DSCheckbox">
      <label
        className={classnames('DSCheckbox__label flex', {
          'items-center': !longDescription,
          'items-start': longDescription
        })}
        htmlFor={id}
      >
        <input
          className="Checkbox__input"
          checked={isChecked}
          id={id}
          name={name}
          onChange={e =>
            onChange ? onChange(e) : setIsChecked(e.currentTarget.checked)
          }
          type="checkbox"
          value={value}
          disabled={disabled}
          {...checkboxProps}
        />
        <div
          className={classnames(
            'DSCheckbox__checkbox pv1 ph1 ba b--default br2',
            {
              'bg-white stone-700': !disabled,
              'bg-subtle-light-gray disabled': disabled
            }
          )}
        >
          <Icon
            className={!isChecked ? 'v-hidden' : ''}
            name="fetch-success"
            width="16px"
            height="16px"
          />
        </div>
        <div>
          {label && (
            <p
              className={classnames('font-16 pl2 flex-auto', {
                'fw-medium': longDescription || shortDescription,
                'margin-t-2': longDescription,
                secondary: !disabled,
                disabled
              })}
            >
              {label}
              {required && (
                <abbr
                  className="rubber ml1"
                  title="required"
                  aria-label="required"
                >
                  *
                </abbr>
              )}
              {shortDescription && (
                <span
                  className={classnames('fw-normal', {
                    'tertiary ml2': !longDescription,
                    'secondary ml1': longDescription
                  })}
                >
                  {shortDescription}
                </span>
              )}
            </p>
          )}
          {longDescription && (
            <p className="font-14 mt1 tertiary pl2">{longDescription}</p>
          )}
        </div>
      </label>
    </div>
  );
}

Checkbox.displayName = 'DSCheckbox';

Checkbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.node,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  longDescription: PropTypes.string,
  shortDescription: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool
  ])
};

export default Checkbox;
